import moment from "moment";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import { ROUTES } from "shared/constants";
import { AppState } from "shared/data/reducers/index";
import { dayMonthFormat } from "shared/lib/datetime";
import { formattedMessageParams } from "shared/messages";

import useSearchInfo from "../useSearchInfo";

const { priceLabel } = defineMessages({
  priceLabel: formattedMessageParams("ShareModal.priceFrom"),
});

type ReturnTypes = {
  url: string;
  title: string;
  aditionalInfo: string;
};

const useFlightInfoForShare = (): ReturnTypes => {
  const [pageUrl, setPageUrl] = useState("");
  useEffect(() => {
    setPageUrl(window.location.href);
  }, []);

  const router = useRouter();
  const intl = useIntl();
  const searchInfo = useSearchInfo();

  const { lowestPrice, currency, defaultCountry } = useSelector(
    (state: AppState) => ({
      lowestPrice: state.search.lowestPrice,
      currency: state.requestorConfig.currency,
      defaultCountry:
        state.storage.frontendSettings?.dealerFrontendSettings
          ?.defaultCountry ?? "",
    })
  );
  if (!router.pathname.includes(ROUTES.RESULTS)) {
    return null;
  }

  const currencySymbol = currency === "CZK" ? "Kč" : currency;

  const showReturnDate =
    searchInfo.isMultiCity || !searchInfo.returnDate
      ? ""
      : ` - ${moment(searchInfo.returnDate).format(
          dayMonthFormat(defaultCountry)
        )}`;

  const travelPlacement = `${searchInfo.travelFrom} - ${searchInfo.travelTo}`;

  const travelDates = `${moment(searchInfo.departureDate).format(
    dayMonthFormat(defaultCountry)
  )}${showReturnDate}`;

  const travelPrice = `${intl.formatMessage(
    priceLabel
  )} ${lowestPrice} ${currencySymbol}`;

  const aditionalInfo = `${travelPlacement}, ${travelDates}, ${travelPrice}`;

  return {
    url: pageUrl,
    title: aditionalInfo,
    aditionalInfo,
  };
};

export default useFlightInfoForShare;
